import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiDatabase from "server";
import UseContext from "../../../../../hooks/useContext";
import usefetchdata from "../../../../../hooks/usefetchdata";
import Button from "../../../../button";
import PdfPageViewer from "../../../../pdfPageViewer/pdfPageViewer";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Modalheader from "../../../components/header";
import useModal from "../../../useModal";

const ModalWelcome = () => {
  const { toggle } = useModal();
  const { tempWorkerData } = usefetchdata();
  const { refreshWorker, setRefreshWorker } = UseContext();
  const [isWelcomeGuideAlreadyRead, setIsWelcomeGuideAlreadyRead] =
    useState(false);
  const [isLastPageVisible, setIsLastPageVisible] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const token = localStorage.getItem("xsrfToken");
  const [pdfFile, setPdfFile] = useState("");
  const [isWaiting, setIsWaiting] = useState(true);

  useEffect(() => {
    if (!token) return;
    setIsWaiting(true);
    ApiDatabase.postPresignPublicFiles(
      {
        token,
        type: "welcomeGuide",
        fileName: "",
      },
      (data) => {
        const urls = Array.isArray(data?.urls) ? data.urls : [];
        const first = urls.find(Boolean) || {};
        const href = first.url || first.uri || "";
        setPdfFile(href || "");
        setIsWaiting(false);
      },
      (err) => {
        console.error(err);
        toast.error("Impossible de charger le guide de bienvenue");
        setPdfFile("");
        setIsWaiting(false);
      }
    );
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsButtonLoading(true);
    ApiDatabase.putWelcomeGuide(
      { token },
      (data) => {
        setIsButtonLoading(false);
        toast.success("Le guide de bienvenue a bien été consulté");
        setRefreshWorker(!refreshWorker);
        toggle();
      },
      (error) => {
        setIsButtonLoading(false);
        toast.error("Une erreur est survenue");
      }
    );
  };

  const lastPageVisible = () => {
    setIsLastPageVisible(true);
  };

  useEffect(() => {
    if (tempWorkerData) {
      setIsWelcomeGuideAlreadyRead(
        tempWorkerData.welcome_guide?.is_read ?? false
      );
    }
  }, [tempWorkerData]);

  return (
    <>
      <Modalheader hide={toggle} hideShow={false}>
        Guide de bienvenue
      </Modalheader>
      <ModalBody>
        {isWaiting ? (
          <div className="flex flex-col shadow border rounded-md p-6 animate-pulse space-y-6">
            <div className="flex items-center space-x-4">
              <div className="h-20 w-20 bg-gray-200 rounded"></div>
              <div className="flex-1 space-y-3">
                <div className="h-5 w-1/3 bg-gray-200 rounded"></div>
                <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              </div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/5 bg-gray-200 rounded"></div>
              <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
              <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
              <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
              <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
              <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
            </div>

            <div className="space-y-2">
              <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
              <div className="grid grid-cols-2 gap-2">
                <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
                <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
                <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
                <div className="h-3 w-2/5 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
        ) : (
          <PdfPageViewer
            file={pdfFile}
            lastPageVisible={() => lastPageVisible()}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
          Annuler
        </Button>
        {isLastPageVisible && !isWelcomeGuideAlreadyRead && !isWaiting ? (
          <>
            {isButtonLoading ? (
              <Button size={"LG"} color={"DISABLED"}>
                Chargement ...
              </Button>
            ) : (
              <Button onClick={handleSubmit} size={"LG"} color={"PRIMARY"}>
                Confirmer
              </Button>
            )}
          </>
        ) : (
          <Button size={"LG"} color={"DISABLED"}>
            Confirmer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalWelcome;
